let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');

module.exports = {
    setSubPage: [
        utils.setFromArgsToState('subPage', ['page', 'sub']),
        utils.setArgByFunction('url', (args) => '/manager/' + args['subPage']),
        redirect.redirectFromArgs
    ]
};



// WEBPACK FOOTER //
// ./signals/account/index.js